import { LoyaltyStationSdk } from './sdk';

export type { SdkConfig } from './types';
export type { LoyaltyStationSdk };

declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore Ignored because there is a conflict of name between gamix-web and loyalty-station, Can bre removed after remove on of them
    gamiphyAsyncInit?: (sdk: LoyaltyStationSdk) => void,
    LoyaltyStation?: LoyaltyStationSdk
  }
}

window.LoyaltyStation = new LoyaltyStationSdk();

setTimeout(() => {
  if (window.gamiphyAsyncInit && window.LoyaltyStation) {
    window.gamiphyAsyncInit(window.LoyaltyStation);
  }
}, 0);
